import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from 'apps/new-web/views/component';
import Image from 'apps/new-web/views/components/image';
import MobileDialog from './mobile-dialog';
import I18n from 'apps/new-web/views/components/i18n';

import LanguagePicker from 'apps/new-web/views/components/footer/language-picker';
import languageLib from 'apps/new-web/lib/language';

export class MobileHeader extends BaseComponent {
  render() {
    return (
      <div className="post-login-mobile-header-container hide-on-desktop">
        <a className="sr-only mobile-skip" href="#main-content"><I18n desc="Invites user to jump ahead to the main content of the page.">Skip to main content</I18n></a>
        <header className="mobile-header">
          <MobileDialog user={ this.props.user } />
          <a href="/" className="header-logo">
            <Image src="img/ifit-logo-dark-mc.svg" alt="iFIT" />
          </a>
          <LanguagePicker
            languages={ this.props.languages }
            lang={ this.props.lang }
            onChange={ languageLib.handleLanguageChange }
          />
        </header>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      lang: state.lang,
      languages: state.languages
    };
  }
)(MobileHeader);
